import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useAdminMessages } from '@/features/messages/hooks/useMessages'
import { MessageList } from '@/features/messages/components/MessageList'

export default function AdminMessagesPage() {
  const navigate = useNavigate()
  const { t } = useTranslation(['admin', 'messages'])
  const [page, setPage] = useState(0)
  const { data, isLoading } = useAdminMessages(page)

  return (
    <div className="max-w-4xl mx-auto p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">{t('messages:list.title')}</h1>
        <button
          onClick={() => navigate('/admin/messages/compose')}
          className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
        >
          {t('messages:list.newMessage')}
        </button>
      </div>

      <div className="bg-white rounded-lg shadow">
        {isLoading ? (
          <div className="p-6 text-center text-gray-500">{t('messages:list.loading')}</div>
        ) : (
          <MessageList
            messages={data?.content ?? []}
            onSelect={(id) => navigate(`/admin/messages/${id}`)}
          />
        )}
      </div>

      {data && data.totalPages > 1 && (
        <div className="flex justify-center gap-2 mt-4">
          <button
            onClick={() => setPage(p => Math.max(0, p - 1))}
            disabled={page === 0}
            className="px-3 py-1 border rounded disabled:opacity-50"
          >
            {t('messages:list.previous')}
          </button>
          <span className="px-3 py-1">
            {page + 1} / {data.totalPages}
          </span>
          <button
            onClick={() => setPage(p => p + 1)}
            disabled={page >= data.totalPages - 1}
            className="px-3 py-1 border rounded disabled:opacity-50"
          >
            {t('messages:list.next')}
          </button>
        </div>
      )}
    </div>
  )
}
